// extracted by mini-css-extract-plugin
export default {"itemLine":"KidsFreeBlock_itemLine__G5TU3","text":"KidsFreeBlock_text__n+ifA"};